import ApiCaller from "./apiCaller";

export const getTabs = () => ApiCaller.get("studio/tab?content_type=site");

export const getGroups = (tabId: string) =>
  ApiCaller.get(`studio/group?studio_tab_id=${tabId}`);

export const createTab = (data: any) => ApiCaller.post(`studio/tab`, data);

export const createGroup = (data: any) => ApiCaller.post(`studio/group`, data);

export const createField = (data: any) => ApiCaller.post(`studio/field`, data);

export const orderTab = (data: any) => ApiCaller.put(`studio/tab/order`, data);

export const orderGroup = (data: any) =>
  ApiCaller.put(`studio/group/order`, data);

export const orderField = (data: any) =>
  ApiCaller.put(`studio/field/order`, data);

export const updateTab = (data: any, id: number) =>
  ApiCaller.put(`studio/tab/${id}`, data);

export const updateGroup = (data: any, id: number) =>
  ApiCaller.put(`studio/group/${id}`, data);

export const updateField = (data: any, id: number) =>
  ApiCaller.put(`studio/field/${id}`, data);

export const getTabDetail = (id: number) => ApiCaller.get(`studio/tab/${id}`);

export const getGroupDetail = (id: number) =>
  ApiCaller.get(`studio/group/${id}`);

export const getFieldDetail = (id: number) =>
  ApiCaller.get(`studio/field/${id}`);
